import { type QueryClient, queryOptions } from "@tanstack/react-query";
import type { Me } from "@zeeta/shared";
import { ApiError, api } from "@/lib/api";

export const meQuery = queryOptions({
  queryKey: ["me"],
  queryFn: async (): Promise<Me | null> => {
    try {
      return await api.get<Me>("/auth/me");
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) return null;
      throw error;
    }
  },
  staleTime: 60_000,
});

/**
 * Reads the signed-in user from the server now, replacing what is cached. Use it right after
 * signing in or changing memberships, before navigating: route guards read the cache, and a stale
 * "not signed in" there would send the user straight back to the login page.
 */
export function refreshMe(queryClient: QueryClient): Promise<Me | null> {
  return queryClient.fetchQuery({ ...meQuery, staleTime: 0 });
}

export const configQuery = queryOptions({
  queryKey: ["config"],
  queryFn: () =>
    api.get<{
      environment: string;
      turnstileSiteKey: string;
      googleEnabled: boolean;
      passwordEnabled?: boolean;
      signupOpen?: boolean;
    }>("/meta/config"),
  staleTime: Number.POSITIVE_INFINITY,
});
